import "./HomePage.styl";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import _ from "lodash";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

import { Container, Row, Col, Button } from "reactstrap";

import Offers from "../components/Offers/Offers";
import NewArticles from "./NewArticles";

import moment from "moment";
moment.locale("pl");

class HomePage extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  redirectToSingle(uid) {
    const { pathname } = this.props;

    this.redirect(pathname + "oferty/" + uid);
  }

  setSort(field, dir) {
    const { setSort } = this.props;

    setSort(field, dir);
  }

  render() {
    const { pathname, params } = this.props;

    const seoTitle =
      "Oferty pracy dla Opiekunek Osób Starszych | OpiekujSie.pl";
    const seoDescription =
      "Tylko najnowsze i wiarygodne oferty pracy! Wybierz swoją ofertę i aplikuj bezpośrednio do agencji online. Wybrane dla Ciebie oferty otrzymuj na maila.";

    return (
      <div className="home-page">
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            {
              property: "og:image",
              content: "https://opiekujsie.pl/static/home-background.jpg",
            },
          ]}
        />
        <Header />

        <div className="hero-section">
          <div className="width-wrapper">
            <div className="title-small">Najnowsze i wiarygodne</div>
            <h1 className="title-large">Oferty dla opiekunek osób starszych</h1>
          </div>
          <div className="width-wrapper google-play">
            <a href="https://play.google.com/store/apps/details?id=com.pqstudio.opiekujsie&hl=pl&utm_source=opiekujsie.pl&utm_campaign=baner_glowny&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
              <img
                alt="pobierz z Google Play"
                src="https://play.google.com/intl/en_us/badges/images/generic/pl_badge_web_generic.png"
              />
            </a>
          </div>
        </div>

        <Offers showPagination showHeader params={params} />

        <div className="blog-section">
          <div className="width-wrapper">
            <Container>
              <Row className="flex-items-xs-center">
                <Col className="section-title text-xs-center" xs="12">
                  Najnowsze artykuły
                </Col>
                <Col
                  className="section-title-second-line text-xs-center"
                  xs="12"
                >
                  Zapisz się do newslettera abyśmy mogli Cię informować na
                  bieżąco!
                </Col>
              </Row>
              <NewArticles />
              <Row>
                <Col className="text-xs-center" xs="12">
                  <Link className="btn btn-secondary btn-lg" to={`/blog`}>
                    ZOBACZ WIĘCEJ
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

HomePage.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default connect((state) => ({}), {})(HomePage);



/** WEBPACK FOOTER **
 ** ./src/browser/home/HomePage.js
 **/